import React, { Component } from 'react'
import {Button,Form} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareSquare } from '@fortawesome/free-regular-svg-icons'
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import editsmall from '../assets/editsmall.png'
import trash from '../assets/trash.png'
import eye from '../assets/eye.png'
import eyeslash from '../assets/eyeslash.png'
import close from '../assets/close.png'
import plus from '../assets/plus.png'
import NumberFormat from 'react-number-format';
// import { Typeahead } from 'react-bootstrap-typeahead';



export default class BasketItem extends Component {
    constructor(props){
        super(props);

        let sdes=this.props.description;

        this.state = {
            description:this.props.description,
            name:this.props.name,
            acname:this.props.name,
            submitedname:this.props.name,
            submiteddescription:sdes,
            submitedStatus:this.props.status,
            submitedprice:this.props.price,
            price:this.props.price,
            new:false,
            addbutton:false,
            acText:false,
            normalText:false,
            desText:false,
            type:this.props.type,
            edited:false,
            ErrorText:'',
            show:this.props.status,
            ErrorTextDes:false,
            selectedSymbol:null,
            selectedSymbol1:[],
        };

        

        this.newbutton = React.createRef();
        this.actiondiv = React.createRef();
        this.closediv = React.createRef();
        this.addbutton = React.createRef();
        this.lblText = React.createRef();

        this.newClick = this.newClick.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.confirmChanges = this.confirmChanges.bind(this);
        this.txtOnChange = this.txtOnChange.bind(this);
        this.dpsTextChange = this.dpsTextChange.bind(this);
        // this.submitEdit = this.submitEdit.bind(this);
        this.checkBrokerNameExist = this.checkBrokerNameExist.bind(this);
        this.checkNameNotRepeat = this.checkNameNotRepeat.bind(this);
        // this.makeid = this.makeid.bind(this);

        this.fields = { value: 'name' };
        this.fields2 = { value: 'full_name' };

    }

    componentDidMount(){
        // if (this.state.submiteddescription!=="" ) alert(this.state.submiteddescription)
    }

    newClick(){

        // this.setState({edited:true,ErrorText:''});
        // if (this.props.new){
        //     this.setState({name:''});
        // }else{
        //     if (this.props.isBasket) this.setState({name:this.state.submitedname})
        //     else this.setState({acname:this.state.submitedname})
        // }

        // if (this.props.type==="dps") return;

        this.props.editedCall();

        if (this.state.type==="new"){
            this.setState({acText:'',name:'',description:''});
        }else if (this.state.type==="default"){
            if (this.props.isBasket) this.setState({name:this.state.submitedname})
            else {
                this.setState({acText:this.state.submitedname,description:this.state.submiteddescription})
                // let d=[];
                // this.props.listData.forEach(element => {
                //     if (element.name===this.state.submitedname){
                //         d.push(element)
                //     }
                // });
                // this.setState({selectedSymbol1:d,description:this.state.submiteddescription})
            }
        }
        this.setState({type:"edit",ErrorText:''});

        this.props.componentStatus(true)
    }

    cancelClick(){
        if (this.props.type==="new") this.setState({type:"new",ErrorText:'',ErrorTextDes:false});
        else this.setState({type:"default",ErrorText:'',ErrorTextDes:false});
        this.props.componentStatus(false)
    }

    confirmChanges(){
        if (this.props.type==="new"){
            let des;
            let name;
            des=this.state.description;
            if (this.props.isBasket) name=this.state.name;
            else name=this.acBroker.value;
            // else{
            //     if (this.state.selectedSymbol===null){
            //         this.setState({ErrorText:'نام کارگزاری نامعتبر است'});
            //         return;
            //     }
            //     console.log(this.state.selectedSymbol)
            //     name=this.state.selectedSymbol.name;
            // }

            if (name===null || name.trim()===''){
                this.setState({ErrorText:'نام نمی تواند خالی باشد'});
                return;
            }
            if (this.checkNameNotRepeat(name)){
                // this.setState({ErrorText:'نام تکراری است'});
                if (this.props.isBasket){
                    this.setState({ErrorText:'نام تکراری است'});
                }else{
                    this.setState({ErrorTextDes:true})
                }
                return;
            }
            let nameid;
            if (!this.props.isBasket){
                nameid=this.checkBrokerNameExist(name);
                if (nameid===0){
                    this.setState({ErrorText:'نام تکراری است'});
                    return;
                }
            }
            // let sdes="("+ des;
            // if (this.props.isBasket) sdes+="%)";
            // else sdes+=")";
            this.setState({submitedname:name,submiteddescription:des});
            this.cancelClick();

            
            this.props.addItem(nameid,name,des);
        }else{
            let des;
            let name;
            des=this.state.description;
            if (this.props.isBasket) name=this.state.name;
            else name=this.acBroker.value;

            if (name===null || name.trim()===''){
                this.setState({ErrorText:'نام نمی تواند خالی باشد'});
                return;
            }

            if (this.checkNameNotRepeat(name)){
                if (this.props.isBasket){
                    this.setState({ErrorText:'نام تکراری است'});
                }else{
                    this.setState({ErrorTextDes:true})
                }
                
                return;
            }

            if (!this.props.isBasket){
                let nameid=this.checkBrokerNameExist(name);
                if (nameid===0){
                    this.setState({ErrorText:'نام کارگزاری مورد نظر نامعتبر است'});
                    return;
                }
            }
            

            let sdes=des;
            this.setState({submitedname:name,submiteddescription:sdes});
            this.cancelClick();

            this.props.editItem(this.props.itemId,name,des);
        }
    }


    checkNameNotRepeat(name){
        if (name===this.state.submitedname) return false;
        let status=false;
        this.props.userBrokerList.forEach(function(entry) {
                if (entry.lable===name){
                    status=true;
                }
        });
        return status;
    }

    checkBrokerNameValid(){

    }

    checkBrokerNameExist(name){
        let status=0;
        this.props.listData.forEach(function(entry) {
                if (entry.name===name){
                    status=entry.id;
                }
            });

        return status;
    }

    // makeid(length) {
    //     var result= '';
    //     var characters= 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     var charactersLength = characters.length;
    //     for ( var i = 0; i < length; i++ ) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //     }
    //     return result;
    // }



    txtOnChange(e){
        if (e.target.name==='description' && this.props.isBasket){
            let telephone = e.target.value;
            if (telephone!=="0" && telephone!=="")
            {
                if (!Number(telephone)) {
                        return;
                }
            }

            e.target.value=e.target.value.replace('.','')
            e.target.value=e.target.value.replace(' ','')
        }
        this.setState({ [e.target.name]: e.target.value });
    }

    dpsTextChange(e){
        let telephone = e.target.value;
        if (telephone!=="0" && telephone!=="")
        {
            let t=telephone.replace(/,/g, '');
            if (!Number(t)) {
                return;
            }
        }

        telephone=e.target.value.replace(/./g, '');
        telephone=e.target.value.replace(/ /g, '');

        this.setState({description: telephone });
        this.props.dpsQuantityChange(telephone.replace(/,/g, ''));
    }

    addBrokerTextChange(event){
        // alert(this.acBrokerText.value)
        // this.setState({brokerName: event.target.value});
    }

    handleKeyPress(target) {
        if(target.charCode===13){
            this.confirmChanges();  
        }
    }

    showHide(){
        this.setState({show:!this.state.show},()=>{
            this.props.showHide(this.props.itemId,this.state.show)
        })
    }

    componentDidUpdate(prevProps,prevStates){
        if (this.state.type==="edit" && !this.props.editedStatus) this.setState({type:this.props.type});
    }

    itemTemplate(data){
        return(
            <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between'}}>
                <div>{data.broker_name}</div>
                {data.lable!==null && data.lable!=='' && data.lable!==undefined && <div style={{fontSize:'12px',color:'var(--gray1)'}}>{data.lable}</div>}
            </div>
        )
    }

    acBrokerChange(){
        // this.acBrokers.value

        let id=0;
        let value=this.acBrokers.value;
        this.props.userBrokersData.forEach(function(entry) {
                if (entry.full_name===value){
                    id=entry.id;
                }
            });

        this.props.increaseBrokerChange(id);
    }

    acSymbolChange(item){
        try {
            if (item.length<1){
                this.setState({selectedSymbol:null,selectedSymbol1:[]});
                return;
            } 
            let s=[];
            s.push(item[0])
            this.setState({selectedSymbol:item[0],selectedSymbol1:s});
        } catch (error) {
            
        }
    }

    render() {
            return (
                
                <div className={this.props.type==="new" ? "newbasketItemBackground":"basketItemBackground"}>
                    {this.state.type==="new" &&
                        <div className="itemNewStyle">
                            <div className="basketItemRight">
                                <div>{this.props.defaultText}</div>
                            </div>
                            <div className="basketItemLeft">
                                <Button variant="light2" onClick={this.newClick} className="plusButton"><img src={plus} alt="plus" style={{height:'20px'}}/></Button>
                            </div>
                        </div>
                    }

                    {this.state.type==="default" &&
                        <div className="itemNewStyle">
                            <div className="basketItemRight">
                                <div>{this.state.submitedname}</div>
                                {this.state.submiteddescription!=='' && this.state.submiteddescription!==null && this.state.submiteddescription!==undefined &&  <div className="basketDefaultDes">({this.state.submiteddescription}{this.props.isBasket && <div>%</div>})</div>}
                            </div>
                            <div className="basketItemLeft">
                                <div className="itemOptions">
                                    <div className="transButton" onClick={this.props.delete}><img src={trash} alt="delete" style={{height:'20px',marginRight:'10px'}}/></div>
                                    <div className="transButton" onClick={this.newClick}><img src={editsmall} alt="edit" style={{height:'20px',marginRight:'10px'}}/></div>
                                    {this.props.showHideEnable && <div className="transButton" onClick={this.showHide.bind(this)}><img src={this.state.show ? eye:eyeslash} alt="edit" style={{width:'25px',marginRight:'10px'}}/></div>}
                                    {this.props.showShare && <div className="transButton" onClick={this.props.share}><FontAwesomeIcon style={{height:'20px',width:'20px',color:'var(--gray1)',marginRight:'10px'}} icon={faShareSquare} /></div>}
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.type==="dps" &&
                        <div className="itemNewStyle">
                            <div className="basketItemRight">
                                <div className="dpsDefaultStyle">
                                    <div className="basketItemRightDps">{this.state.submitedname}</div>
                                    <div>&nbsp;:&nbsp;</div>
                                    <div style={{display:'flex',flexDirection:'row',fontSize:'12px'}}>
                                        <NumberFormat allowNegative={true} value={this.props.price} displayType={'text'} thousandSeparator={true} />
                                        <div >&nbsp;ریال</div>
                                    </div>
                                </div>
                            </div>
                            <div className="basketItemLeft">
                                <div className="itemOptions">
                                    <div>
                                        <NumberFormat 
                                        name="description"
                                        placeholder={this.props.desHolder}
                                        className="form-control inputStyleItemsDes centeredText dpsSuggestInput"
                                        displayType={'input'} 
                                        thousandSeparator={true}
                                        onChange={this.dpsTextChange}
                                        value={this.state.description} />
                                    </div>
                                    

                                    <div style={{marginLeft:'5px',whiteSpace:'nowrap'}}>
                                        تعداد سهم:
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.type==="increase" &&
                        <div className="itemNewStyle">
                            <div className="basketItemRightIncrease" title={this.state.submitedname}>
                                    {this.state.submitedname}
                            </div>
                            <div style={{flex:'1',maxWidth:'50px'}} />
                            <div className="basketItemLeft">
                                <div className="itemOptions">
                                    <AutoCompleteComponent change={this.acBrokerChange.bind(this)} itemTemplate={this.itemTemplate} showPopupButton={true} className={this.state.brokerFalse ? "inputStyleRed increaseSuggestInput":"inputStyleForm increaseSuggestInput"} ref={(scope) => this.acBrokers = scope} filterType="Contains" enableRtl='true' noRecordsTemplate="موردی یافت نشد" popupHeight="850px" dataSource={this.props.userBrokersData} fields={this.fields2} placeholder="کارگزاری" autofill={true} />
                                    <div style={{width:'5px'}}/>
                                    <NumberFormat 
                                    name="description"
                                    placeholder={this.props.desHolder}
                                    className="form-control inputStyleItemsDes centeredText dpsSuggestInput"
                                    displayType={'input'} 
                                    thousandSeparator={true}
                                    onChange={this.dpsTextChange}
                                    value={this.state.description} />
                                    <div style={{margin:'0px 5px',whiteSpace:'nowrap'}}>
                                        تعداد سهم:
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.type==="edit" &&
                        <div className="itemEditStyle">
                            {this.props.isBasket && <Form.Control onKeyPress={this.handleKeyPress.bind(this)} name="name" placeholder={this.props.nameHolder} onChange={this.txtOnChange} value={this.state.name} className={this.state.ErrorText!=='' ? "inputStyleForm redBorder":"inputStyleForm"}/>}
                            {this.props.isBasket && <div style={{height:'10px'}}/>}
                            {this.props.isBasket &&
                            <div style={{display:'flex',flexDirection:'row',width:'100%'}}>  
                                    <Form.Control onKeyPress={this.handleKeyPress.bind(this)} name="description" placeholder={this.props.desHolder} onChange={this.txtOnChange} value={this.state.description} className="inputStyleItemsDes"/>
                                    <div style={{width:'40%',display:'flex',flexDirection:'row'}}>
                                        <Button variant="secondary" ref={this.addbutton} onClick={this.confirmChanges} className="btnConfirmWhite">تایید</Button>
                                        <Button variant="danger" onClick={this.cancelClick} className="btnCancel"><img src={close} alt="close" style={{height:'12px'}}/></Button>
                                    </div>
                            </div>
                            }
                            {!this.props.isBasket && <AutoCompleteComponent value={this.state.acText} filterType="Contains" enabled={this.props.type==="new" ? true:false} noRecordsTemplate="موردی یافت نشد" ref={(scope) => this.acBroker = scope} change={this.addBrokerTextChange.bind(this)} enableRtl={true} className={this.state.ErrorText!=='' ? "inputStyleRed":"inputStyleForm"} style={{width:'100%',fontSize:'12px'}} id="atcelement" dataSource={this.props.listData} fields={this.fields} placeholder={this.props.nameHolder}/>}
                            
                            {!this.props.isBasket && <div style={{height:'10px'}}/>}
                            {!this.props.isBasket &&
                            <div style={{display:'flex',flexDirection:'row',width:'100%'}}>  
                                    <Form.Control onKeyPress={this.handleKeyPress.bind(this)} name="description" placeholder={this.props.desHolder} onChange={this.txtOnChange} value={this.state.description} className={this.state.ErrorTextDes ? "inputStyleItemsDesRed":"inputStyleItemsDes"}/>
                                    <div style={{width:'40%',display:'flex',flexDirection:'row'}}>
                                        <Button variant="secondary" ref={this.addbutton} onClick={this.confirmChanges} className="btnConfirmWhite">تایید</Button>
                                        <Button variant="danger" onClick={this.cancelClick} className="btnCancel"><img src={close} alt="close" style={{height:'12px'}}/></Button>
                                    </div>
                            </div>
                            }
                        </div>
                    }
                </div>
            )
        
        
    }
}
